import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { trackShipmentPOST } from "../../api/trackingApi";
import "../styles/Tracking.css";

const Tracking = () => {
  const location = useLocation();
  const awbArray = location.state?.awbArray || [];

  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (awbArray.length > 0) {
      fetchAllShipments();
    }
  }, []);

  const fetchAllShipments = async () => {
    try {
      setLoading(true);

      const requests = awbArray.map((awb) =>
        trackShipmentPOST(awb)
      );

      const responses = await Promise.all(requests);

      const results = responses
        .map((res, index) => {
          if (res.data?.STATUS === 1) {
            return {
              awbno: awbArray[index], // ✅ correct AWB
              Header: res.data.Header?.[0],

              // ✅ Sort latest first
              History: (res.data.History || []).sort(
                (a, b) =>
                  new Date(b.Status_Date + " " + b.ST_TIME) -
                  new Date(a.Status_Date + " " + a.ST_TIME)
              ),
            };
          }
          return null;
        })
        .filter(Boolean);

      setShipments(results);
    } catch (error) {
      console.error("Tracking Error:", error.message);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Status color function
  const getStatusColor = (status) => {
    if (!status) return "black";
    const s = status.toLowerCase();

    if (s.includes("delivered")) return "green";
    if (s.includes("out for delivery")) return "orange";
    if (s.includes("booked")) return "blue";

    return "gray";
  };

  if (loading) {
    return (
      <div className="tracking-container">
        <p>Loading tracking details...</p>
      </div>
    );
  }

  return (
    <div className="tracking-container">

      {shipments.map((shipment, index) => (
        <div key={index} className="shipment-box">

          {/* ===== Shipment Detail ===== */}
          <div className="shipment-header">
            Shipment Detail - {shipment.awbno}
          </div>

          <table className="tracking-table">
            <thead>
              <tr>
                <th>AWB No</th>
                <th>Origin</th>
                <th>Destination</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{shipment.awbno}</td>
                <td>{shipment.Header?.ORIGIN}</td>
                <td>{shipment.Header?.Destination}</td>
                <td
                  style={{
                    color: getStatusColor(shipment.Header?.Status),
                    fontWeight: "bold",
                  }}
                >
                  {shipment.Header?.Status}
                </td>
              </tr>
            </tbody>
          </table>

          {/* ===== Extra Details ===== */}
          <div className="extra-details">
            <p><strong>Shipper:</strong> {shipment.Header?.ShipperName}</p>
            <p><strong>Consignee:</strong> {shipment.Header?.ConsigneeName}</p>
            <p><strong>Weight:</strong> {shipment.Header?.WT_KG} KG</p>
            <p><strong>Received By:</strong> {shipment.Header?.REC_BY}</p>
          </div>

          {/* ===== POD Image ===== */}
          {shipment.Header?.POD_Image && (
            <div className="pod-section">
              <p><strong>POD Image:</strong></p>
              <img
                src={shipment.Header.POD_Image}
                alt="POD"
                className="pod-image"
              />
            </div>
          )}

          {/* ===== Shipment History ===== */}
          <div className="shipment-header">Shipment History</div>

          <table className="tracking-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Time</th>
                <th>Status</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {shipment.History.length > 0 ? (
                shipment.History.map((item, i) => (
                  <tr key={i}>
                    <td>{item.Status_Date}</td>
                    <td>{item.ST_TIME}</td>
                    <td
                      style={{
                        color: getStatusColor(item.Status),
                        fontWeight: "bold",
                      }}
                    >
                      {item.Status}
                    </td>
                    <td>{item.POD_REM}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No history available
                  </td>
                </tr>
              )}
            </tbody>
          </table>

        </div>
      ))}

    </div>
  );
};

export default Tracking;